export default ":host #create-project-form {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  padding: 5em;\n}"